// Polyfill IE11; see https://github.com/facebook/create-react-app/tree/master/packages/react-app-polyfill
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import svg4everybody from 'svg4everybody';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import configureStore from './store/';

import * as Setup from './setup/containers';
import ErrorPage from './common/components/ErrorPage';
import { SETUP_PERMISSION } from './setup/constants';
import { unregister } from './serviceWorker';
import mcLib from './utilities/mc-lib';

import '@salesforce-ux/design-system/assets/styles/salesforce-lightning-design-system.css';

import Intl from './i18n/containers/Intl';

import { IconSettings, Settings } from '@salesforce/design-system-react';
import actionSprite from '@salesforce-ux/design-system/assets/icons/action-sprite/svg/symbols.svg';
import customSprite from '@salesforce-ux/design-system/assets/icons/custom-sprite/svg/symbols.svg';
import utilitySprite from '@salesforce-ux/design-system/assets/icons/utility-sprite/svg/symbols.svg';
import standardSprite from '@salesforce-ux/design-system/assets/icons/standard-sprite/svg/symbols.svg';
import doctypeSprite from '@salesforce-ux/design-system/assets/icons/doctype-sprite/svg/symbols.svg';

// SVG Polyfill for IE/Edge
svg4everybody();

const store = configureStore();
const router = hasAccess => (
  <Provider store={store} appElement={document.getElementById('root')}>
    <Intl>
      <BrowserRouter>
        <IconSettings
          standardSprite={standardSprite}
          utilitySprite={utilitySprite}
          actionSprite={actionSprite}
          doctypeSprite={doctypeSprite}
          customSprite={customSprite}
        >
          <Route
            exact
            path="/setup"
            component={hasAccess ? Setup.Dashboard : ErrorPage.Forbidden}
          />
          <Route
            exact
            path="/settings"
            component={hasAccess ? Setup.Settings : ErrorPage.Forbidden}
          />
          <Route exact path="/error" component={ErrorPage.GeneralError} />
        </IconSettings>
      </BrowserRouter>
    </Intl>
  </Provider>
);

Settings.setAppElement(document.getElementById('root'));

mcLib.hasAccess(
  SETUP_PERMISSION.OBJECT,
  SETUP_PERMISSION.OPERATION,
  hasAccess => {
    ReactDOM.render(
      router(hasAccess && !hasAccess.err),
      document.getElementById('root')
    );
  }
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();
